import { OrderEditMode } from '../../00_modules/core/models/OrderEditMode';
import { OrderInEditMode, OrderStateChanged } from '../interface/notification.interface';

export class SetOrderInEditMode {
    public static readonly type = '[OrderInEditMode] Set Order in edit mode';

    constructor(public readonly order: OrderInEditMode) {}
}

export class ResetOrderInEditMode {
    public static readonly type = '[OrderInEditMode] Reset Order in edit mode';
}

export class NotificationChanged {
    public static readonly type = '[Notification] Notification changed';

    constructor(public orderStateChanged: OrderStateChanged) {}
}

export class AddAllOrder {
    public static readonly type = '[Notification] Add all order';

    constructor(public orders: OrderEditMode[]) {}
}

export class UpdateOneOrder {
    public static readonly type = '[Notification] Update one order';

    constructor(public order: OrderEditMode) {}
}
